import React, { useEffect, useState } from 'react';
import { useAuth } from '../../Contexts/AuthContext';
import UI_Card from '../ERUMAUI/UI_Card';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_LogGroup from '../ERUMAUI/UI_LogGroup'
import Icon_Color_Document from '../../Assets/Icons/Icon_Color_Document.png'


export default function Document_Schedule_Details() {
    const { Account, Loading, Logout } = useAuth();
    const { Schedules, Schedules_Pending_Initial, Schedules_Pending_Final, Time_Range_Parse, Time_Parse, Status_Parse, Schedule_Display, Schedules_ByUser, Schedule_Information, Schedule_Information_History } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const { Accounts_Fetch_ByID_Many_Basic, Account_Fetch_ByID_FromState } = useAccounts();
    const [Accounts, Accounts_Set] = useState({});

    useEffect(() => {

        const allIDs = [
            Schedule_Information?.Requester?.RequesterID,
            Schedule_Information?.Approval?.Initial?.ApproverID,
            Schedule_Information?.Approval?.Final?.ApproverID,
            Schedule_Information?.Reschedule?.ReschedulerID,
            Schedule_Information?.Relocate?.RelocatorID,
        ];

        Accounts_Fetch_ByID_Many_Basic(allIDs).then(Accounts_Set);
    }, [Schedule_Information]);
    const getName = (id) => Accounts[id]?.Name || "Loading...";
    const getEmail = (id) => Accounts[id]?.Email || "Loading...";

    if (Loading) {
        return null;
    }

    const Display_Information = () => {
        return (
            <>
                <UI_Divider Text="Activity information" />
                <h1 className='General_Title'>
                    {Schedule_Information.Name}
                </h1>
                <p className='General_Paragraph'>
                    {Schedule_Information.Description}
                </p>
                <div className='General_Split' Split="2" style={{ marginTop: "20px", gap: "10px" }}>
                    <div>
                        <p className='General_Paragraph'>
                            Requested by:
                        </p>
                        <UI_Card
                            Type="Schedule_List"
                            Figure={{
                                Title: getName(Schedule_Information.Requester.RequesterID),
                                Main: getEmail(Schedule_Information.Requester.RequesterID)
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <p className='General_Paragraph'>
                            Activity type:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Schedule_Information.Activity.Type}</b>
                        </p>
                        {Schedule_Information.Subject !== "" || Schedule_Information.Subject !== "-" ?
                            <>
                                <p className='General_Paragraph'>
                                    Subject:
                                </p>
                                <p className='General_Paragraph'>
                                    <b>{Schedule_Information.Activity.Subject}</b>
                                </p>
                            </>
                            :
                            ""
                        }
                    </div>


                </div>
                <UI_Divider Text="Schedule information" />
                <div className='General_Split' Split="2">
                    <p className='General_Paragraph'>
                        Date requested:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Time_Parse(Schedule_Information.Time.Start, "Date")}</b>
                    </p>
                    <p className='General_Paragraph'>
                        Time from:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Time_Parse(Schedule_Information.Time.Start, "Time")}</b>
                    </p>
                    <p className='General_Paragraph'>
                        Time to:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Time_Parse(Schedule_Information.Time.End, "Time")}</b>
                    </p>
                    <p className='General_Paragraph'>
                        Location:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Room_Get_Address(Schedule_Information.RoomID)}</b>
                    </p>
                </div>
                {Schedule_Information.Reschedule.Date ?
                    <>
                        <UI_Divider Text="Reschedule information" />
                        <div className='General_Split' Split="2">
                            <p className='General_Paragraph'>
                                Reschedule reason:
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Schedule_Information.Reschedule.Reason}</b>
                            </p>
                            <p className='General_Paragraph'>
                                Date rescheduled:
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Time_Parse(Schedule_Information.Reschedule.Date)}</b>
                            </p>
                            <p className='General_Paragraph'>
                                Rescheduled by:
                            </p>
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: getName(Schedule_Information.Reschedule.ReschedulerID),
                                    Main: getEmail(Schedule_Information.Reschedule.ReschedulerID)
                                }}
                            />
                            {/* <p className='General_Paragraph'>
                                    <b>{getName(Schedule_Information.Reschedule.ReschedulerID)}</b>
                                </p> */}
                        </div>
                    </>

                    :
                    ""
                }

                {Schedule_Information.Relocate.Date ?
                    <>
                        <UI_Divider Text="Relocation information" />
                        <div className='General_Split' Split="2">
                            <p className='General_Paragraph'>
                                Relocation reason:
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Schedule_Information.Relocate.Reason}</b>
                            </p>
                            <p className='General_Paragraph'>
                                Date relocated:
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Time_Parse(Schedule_Information.Relocate.Date)}</b>
                            </p>
                            <p className='General_Paragraph'>
                                Relocated by:
                            </p>
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: getName(Schedule_Information.Relocate.RelocatorID),
                                    Main: getEmail(Schedule_Information.Relocate.RelocatorID)
                                }}
                            />
                            {/* <p className='General_Paragraph'>
                                    <b>{getName(Schedule_Information.Relocate.RelocatorID)}</b>
                                </p> */}
                        </div>
                    </>

                    :
                    ""
                }

                <UI_Divider Text="Application information" />
                <div className='General_Split' Split="2">
                    <p className='General_Paragraph'>
                        Request status:
                    </p>
                    <UI_ChipGroup Items={Status_Parse(Schedule_Information)} />
                    <p className='General_Paragraph'>
                        Date applied:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Time_Parse(Schedule_Information.DateCreated)}</b>
                    </p>
                    {Schedule_Information.Approval.Initial.State != "Pending" ?
                        <>
                            <p className='General_Paragraph'>
                                {
                                    Schedule_Information.Approval.Initial.State == "Approved" ?
                                        "Date approved by OSA:"
                                        :
                                        Schedule_Information.Approval.Initial.State == "Rejected" ?
                                            "Date rejected by OSA:"
                                            :
                                            ""
                                }
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Time_Parse(Schedule_Information.Approval.Initial.DateApproved)}</b>
                            </p>
                            <p className='General_Paragraph'>
                                OSA representative:
                            </p>
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: getName(Schedule_Information.Approval.Initial.ApproverID),
                                    Main: getEmail(Schedule_Information.Approval.Initial.ApproverID)
                                }}
                            />
                            {/* <p className='General_Paragraph'>
                                    <b>{getName(Schedule_Information.Approval.Initial.ApproverID)}</b>
                                </p> */}
                            {Schedule_Information.Approval.Initial.State === "Rejected" ?
                                <>
                                    <p className='General_Paragraph'>
                                        Rejection reason:
                                    </p>
                                    <p className='General_Paragraph'>
                                        <b>{Schedule_Information.Approval.Initial.RejectionReason}</b>
                                    </p>
                                </>
                                :
                                ""
                            }
                        </>
                        :
                        ""
                    }
                    {Schedule_Information.Approval.Final.State != "Pending" ?
                        <>
                            <p className='General_Paragraph'>
                                {
                                    Schedule_Information.Approval.Final.State == "Approved" ?
                                        "Date approved by GSU:"
                                        :
                                        Schedule_Information.Approval.Final.State == "Rejected" ?
                                            "Date rejected by GSU:"
                                            :
                                            ""
                                }
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Time_Parse(Schedule_Information.Approval.Final.DateApproved)}</b>
                            </p>
                            <p className='General_Paragraph'>
                                GSU representative:
                            </p>
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: getName(Schedule_Information.Approval.Final.ApproverID),
                                    Main: getEmail(Schedule_Information.Approval.Final.ApproverID)
                                }}
                            />
                            {/* <p className='General_Paragraph'>
                                    <b>{getName(Schedule_Information.Approval.Final.ApproverID)}</b>
                                </p> */}
                            {Schedule_Information.Approval.Final.State === "Rejected" ?
                                <>
                                    <p className='General_Paragraph'>
                                        Rejection reason:
                                    </p>
                                    <p className='General_Paragraph'>
                                        <b>{Schedule_Information.Approval.Final.RejectionReason}</b>
                                    </p>
                                </>
                                :
                                ""
                            }

                        </>
                        :
                        ""
                    }
                </div>
                {/* <UI_Divider Text="Applicant information" />
                    <div className='General_Split' Split="2">
                        <p className='General_Paragraph'>
                            Applicant name:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{getName(Schedule_Information.Requester.RequesterID)}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Applicant email:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{getEmail(Schedule_Information.Requester.RequesterID)}</b>
                        </p>
                    </div> */}
                <UI_Divider Text="Attendee information" />
                <div className='General_Split' Split="2">
                    <p className='General_Paragraph'>
                        Number of attendees:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Schedule_Information.Activity.Attendees.Names.length > 0 ? Schedule_Information.Activity.Attendees.Names.length : "None listed"}</b>
                    </p>
                </div>
                {Schedule_Information.Activity.Attendees.Names.length > 0 ?
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "5px", marginTop: "10px" }}>
                        {Schedule_Information.Activity.Attendees.Names.map((Item) => (
                            <>
                                <p className='General_Paragraph' style={{ margin: "0" }}>
                                    {Item}
                                </p>
                            </>
                        ))}
                    </div>
                    :
                    ""
                }
                {Schedule_Information.Request_Airconditioner ?
                    <>
                        <UI_Divider Text="Additional requests" />
                        <div className='General_Split' Split="2">
                            <p className='General_Paragraph'>
                                {Schedule_Information.Approval.Final.State === "Approved" ?
                                    "Approved to use room airconditioning:"
                                    :
                                    "Requesting for room airconditioning:"
                                }
                            </p>
                            <p className='General_Paragraph'>
                                <b>{Schedule_Information.Request_Airconditioner ? "Yes" : "No"}</b>
                            </p>
                        </div>
                    </>
                    :
                    ""
                }
                <UI_Divider Text="Equipment information" />
                <div className='General_Split' Split="2">
                    <p className='General_Paragraph'>
                        Number of equipment:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Schedule_Information.Equipment.length > 0 ? Schedule_Information.Equipment.length : "None listed"}</b>
                    </p>
                </div>
                {Schedule_Information.Equipment.length > 0 ?
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "5px", marginTop: "10px" }}>
                        {Schedule_Information.Equipment.map((Item) => (
                            <>
                                <p className='General_Paragraph' style={{ margin: "0" }}>
                                    {Item}
                                </p>
                            </>
                        ))}
                    </div>
                    :
                    ""
                }
                <UI_Divider Text="Delegated staff" />
                <div className='General_Split' Split="2">
                    <p className='General_Paragraph'>
                        Number of staffs delegated by the GSU:
                    </p>
                    <p className='General_Paragraph'>
                        <b>{Schedule_Information.DelegatedStaff.length > 0 ? Schedule_Information.DelegatedStaff.length : "None listed"}</b>
                    </p>
                </div>
                {Schedule_Information.DelegatedStaff.length > 0 ?
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5px", marginTop: "10px" }}>
                        {Schedule_Information.DelegatedStaff.map((Item) => (
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: Account_Fetch_ByID_FromState(Item).Name,
                                    Main: Account_Fetch_ByID_FromState(Item).Email
                                }}
                            />
                        ))}
                    </div>
                    :
                    ""
                }
                <UI_Divider Text="Activity history" />
                <UI_LogGroup Logs={Schedule_Information_History} />
            </>
        )
    }

    return (
        <UI_UpdatingStatus
            State={Schedule_Information ? "Good" : "Bad"}
            Bad={{
                Type: "Default",
                Icon: Icon_Color_Document,
                Title: "No request loaded",
                Text: "This panel will display the information of a request once you select one from the queue on the left."
            }}
            Good={{
                Type: "Custom",
                Content: <Display_Information />
            }}
        />
    )
}